var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.subject
    ? _c("div", { staticClass: "c-controls c-controls" }, [
        _c("div", { staticClass: "c-controls__group" }, [
          _c("label", { staticClass: "c-controls__label" }, [
            _vm._v("Antwoord ingestuurd")
          ]),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "c-team-status" },
            _vm._l(_vm.teams, function(team) {
              return _c(
                "li",
                {
                  key: team.uuid,
                  staticClass: "c-team-status__item",
                  class: {
                    "team-finished": _vm.teamHasAnswer(team)
                  }
                },
                [_vm._v("\n\t\t\t\t" + _vm._s(team.name) + "\n\t\t\t")]
              )
            }),
            0
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }